module.exports = __webpack_public_path__ + "media/images/barbecue_kids_plan-a3c25aca0ba813eb7d1122a74061d0d5.jpg";